export default [
  {
    version: 'Beta 3.3',
    changes: [
      'Reverted Pokemon being able to revive through healing.  Revival must be done by the Help maneuver, Reviver seeds, or certain Features specifying as such.',
      'Reduced Help maneuver difficulty from 15 to 10.',
      'Added sections for the item bag, jobs, skill bonuses, stage changes, and modifiers to Creating a Character.',
      'Added Brick-Tough, Wary Fighter, and Odor Sleuth.',
      'Added improvements for various techniques.',
      'Increased prerequisites and reduced usage frequency across the board for Techniques to reduce spam.',
      'Stalwart Fighter and Adrenaline Junkie now reduce stats when used, and are now Once per Battle.',
      'Specific definition added for “Attack,” under Combat -> Attacking, and in the glossary.',
      'Stat reduction moves are explicitly considered attacks, see blurb in Moves -> Creating a Move.',
      'Advanced Status Moves now grant a Feature.',
      'Web of Knowledge reworked to prevent an exploit with Swarm.  Usage frequency increased.',
      'Knock Off given usage limit and Move tier restrictions.',
      'Superconductor behavior changed, now works with thrown Spikes.',
      'Well of Life moved from at any time to free action to prevent shenanigans with Grassy Terrain.',
      'Burrower no longer works while Immobilized.',
      'Tremors behavior clarified.',
      'Frozen Heart behavior changed from a duration to a save.  Only applies to bad conditions.',
      'Helping Hand given usage restrictions.',
      'Magic Bounce targeting specified more clearly.',
      'Wide Guard now immobilizes the user.',
      'Reworded Meteor Shield to use Boulders.',
      'Mirror Shield restriction added.',
      'Fey Bargain, Clash, Bide, and the Jump maneuver cutoff now require damaging attacks to proc.',
      'Added distance restriction & reduced potency of Jungle Bracer.',
      'Encourage specifically applies on ally turn.',
      'Moved Taunt to be a Deception technique.',
      'Updated Restraint Scarf to work like Sturdy.',
      'Silver rank rewards updated to use Def/Sp.Def stat for damage reduction instead of armor class.',
      'Removed minimum d4 from Lucky Chant.  Added clause for reduction past minimum size in Playing The Game -> Rolling Dice.',
      'Moved Tenacity to Rescuer No Prerequisites.',
      'Added Minimize.',
      'Updated Resilient and instances of the Sure-Hit condition to reflect the new status condition rules.',
      'Replaced Elemental Sentry with Item Synthesizer.',
      'Swapped requirements for Clash and Warmed Up, increased uses for Clash.',
      'Fixed issues with Frozen, Sleep, Sure-Hit, and Confusion statuses.  Sleep now requires an attack to deal damage to heal the condition.',
      'Added "Hidden Trap" Object to prevent abuse.',
      'Cleaned up definitions for obstacles to remove double procs.',
      'Added Campaigns and Missions to the Game Master\'s Guide.',
      'Improved damage of Advanced and Intermediate enemies.'
    ]
  },
  {
    version: 'Beta 3.2',
    changes: [
      'Mixed Attacker improvement restricted.',
      'Stronger Together is now Twice per Extended Rest, from Once per Battle.  Altered behavior.',
      'Added Guild Sentry.',
      'Power Pitcher now requires additional Sleight of Hand points to qualify.',
      'Added Type Shift condition.  Raised price of Typeshift wands, and adjusted Soak and other Features to use the new condition.',
      'Pokemon may jump over Objects specifically.',
      'Temporary Hit Points may not be applied to Fainted Pokemon.',
      'Buffed Coordinator and Dancing move styles.',
      'Added cancel-out loophole for Fell Stinger.',
      'Endure given Advantage until used successfully.',
      'Dimensional Rift attacks capped, may now use Status moves.',
      'Chasms from Fissure are now classified as Objects.',
      'Added restrictions to Helping Hand, swapped prerequisites with Born to Be a Master.',
      'Reverted Entrainment back to Twice per Extended Rest, added restriction.',
      'Added clause for self-targeting in the Friendly Fire section.  Nerfs Mirror Shield by proxy.',
      'Reverted Diamond rank reward to Platinum rank.',
      'Added note to Platinum rank reward, adjusted Seeker and Explorer rewards.',
      'Reverted Taunt to previous behavior.',
      'Loosened Fainting requirement for Healing Wish.',
      'Made healing from Field Medic and Survivalist mutually exclusive.',
      'Fixed an exploit with Dungeonsense.',
      'Warmed Up now adds +2 instead of +3 to compensate for other changes.',
      'Clash now auto-crits.',
      'Added rules for specific conditions to Salt in the Wound.',
      'Technician replaced with Hidden Power.',
      'Nullify Orb behavior nerfed.',
      'Lunar Veil given usage limit.',
      'Lustrous Sickle given action economy restriction.',
      'Added time limit for generated Obstacles.',
      'Status conditions now tick down at the start of turn, to match various Obstacles.',
      'Added Supervisor, Counter Hitter, Resilient, and Legendary Resistance Boss Features.',
      'Added Legendary Boss enemy archetype above Advanced.',
      'Various clarifications on wordage.'
    ]
  },
  {
    version: 'Beta 3.1',
    changes: [
      'Removed New Technique from character creation for balance.',
      'Moved Leveling Up & Evolution to the bottom of Playing The Game.',
      'Added clause about duplicate Techniques.',
      'Added Skill improvement to Mixed Attacker (Athletics).',
      'Fixed Move graphics.',
      'Vine Whip only specifically requires a Standard Action for interacting with items, switches, etc.  Made damage optional.',
      'Restricted Telekinetic during Opportunity Attacks.',
      'Frozen condition now provides damage immunity, and has a sliding mechanic.',
      'Updates to Slippery Slope (was Brittle Crystal), Shatter, and Thermodynamism to account for the Freeze changes.',
      'Added ceiling to Taunt.  Now uses a Free Action, limited 2x per Battle.',
      'Encourage behavior changes to give Rescuer more options.',
      'Oblivion Feather uses new Freeze mechanics.'
    ]
  },
  {
    version: 'Beta 3.0',
    changes: [
      'Moved retraining, Feature & Technique usage to their respective sections.',
      'Moved Character creation under Playing the Game.  Condensed section.',
      '“Adjacent” terminology changed to “Nearby.”',
      'Resting cannot be done in a dungeon.',
      'Removed Willpower checks for exhaustion, since there are Willpower techniques now.',
      'Added text for using moves out of combat to the Moves section.  Improved Move graphics & text.',
      'Effect moves now scale with level if you own the Type they are compatible with.  Base Difficulty reduced.',
      'Skills overhaul. Moved Skills to their own major section.  Techniques are now qualified for by investing Skill Points.  The “Skilled” Technique has been converted to a Level-Up mechanic.',
      'Removed Leveling Up section, rolled it into Playing The Game.',
      'Added Overpacker, Scatter Foes, Stronger Together, Eye for Coin, Folklore, Smooth Landing, Blend In techniques.',
      'Intimidator now caps out to 20.',
      'Cleaned up mentions of ACP & ACS.',
      'Added minutiae regarding targeting.',
      'Help maneuver buffed to 15+ instead of 18+.',
      'Snarl nerfed to Once per Turn.',
      'Drake\'s Challenge capped to 25.',
      'Big buff to Defiance.',
      'Noble Sacrifice changed to Chant of the Ancestor.',
      'Added additional damage die to Pinnacle of Evolution.',
      'Clarified Speedster for Pokémon with multiple turns.',
      'Supercharged Auxiliary Battery.',
      'Rework to Storm Surge.',
      'Nerfed Relentless Training, again.',
      'Added minutiae to Possession.',
      'Adjusted Dimensional Rift to be over in a single turn.',
      'Harvest now interacts with all discarded items, not just items that are used directly.',
      'Rework to Chlorophyll.',
      'Sandstorm tiles now require twice as much distance to Travel.  Does not apply if you are immune to Sandstorm effects.',
      'Caustic Leap now has a saving throw to avoid the initial hit.',
      'Fixed Telekinetic™',
      'Replaced Psionic Blast with Sway.',
      'Removed recoil from Frozen Heart, now has a duration related to Willpower.',
      'Trample now works with Rock Tearing style moves.',
      'Added save to Aqua Bubble.',
      'Battle Cry now caps out to 15, scaling with Empathy skill.',
      'Added Trained Professional, since Intimidator was moved to the Skills section.',
      'Added immunities to Elemental Sentry.',
      'Increased Quick Seed price.',
      'Added QoL to Reviver Seeds.',
      'Tweaked Bag of Tricks.',
      'Status Conditions can no longer be extended.',
      'Pokémon now wake up when hit by attacks or when a save is failed.',
      'Burn damage now scales with Move tier.',
      'Confusion now scales with Move tier.',
      'Pitfall traps now specifically deal falling damage.',
      'Mold Breaker changed to Deadly Statuses to avoid confusion.'
    ]
  },
  {
    version: 'Beta 2.0',
    changes: [
      'Changed HP generation mechanics.  HP stat is no longer rolled.  1d4 HP is added during Level Up.',
      'You may now fail Saving Throws by choice.',
      'You can only help adjacent Pokémon.',
      'Updated text for Powder Pro.',
      'Punishment replaced with Snarl.',
      'Living Nightmare replaced with Thief.',
      'Charge adjusted to limit the number of dice.',
      'Shattering Strikes replaced with Underdog.',
      'Ignition now works with Fire-Type Features.',
      'Sunburn now works with Fire-Type Features.',
      'Flare changed to Volatile Flare.',
      'Leech Seed replaced with Strength Sap.',
      'Added distance to Dig.',
      'Increased range of Terraform.',
      'Added Move tier to Ice Ball.',
      'Frozen Heart can now be activated at any time.',
      'Shuffled requirements for various Normal features.  Entrainment is now Once per Battle.',
      'Sticky Hold replaced with Deadly Poison.',
      'Caustic Ooze no longer affects Poison-Types.',
      'Belch may now trigger some Poison-Type Features.',
      'Venom Drench replaced with Noxious Gas Special capstone.',
      'Shuffled requirements for various Poison features.',
      'Added Golden Fossils and Move tier to Boulder Bowling.',
      'Sediment Barrier boulders explicitly block ranged attacks.',
      'Added action type to Stealth Rock.',
      'Nerfed Fortress.',
      'Reconfigure Armor (standard) now triggers Defense stages on 15+.',
      'Reconfigure Armor (heavy) now only prevents being moved by enemies.',
      'Mirror Shield may now optionally reflect incoming attacks.',
      'Added further conditions to Aqua Bubble.',
      'Added Type Synergy Technique.',
      'Pokémon may only Jump in a straight line under normal conditions.',
      'Improved move upgrade mechanics.',
      'Added Mastery compatibility with Effect style moves.',
      'Adjusted Toxic and Swagger.',
      '"Direct" damage is now "Environmental" damage, to avoid confusion with direct attacks.',
      'Improved Lucky Chant.',
      'Further adjustments to Double Team.',
      'Rules clarification for Thrifty.',
      'Reverted Quick-Access Bag to Twice per Battle.',
      'Cage Match now has a… deterrent.',
      'Updated various tile effect features for clarity.',
      'Update “Thorn” throwing items to use the name “Spike”',
      'Added range to Trickster Seed.',
      'Clarified Max Elixir.',
      'Clarified usage for Bag of Tricks.',
      'Added Golem Mask, Techno Drive, and Ivy Cudgel.',
      'Increased HP for Advanced enemies by 15HP.',
      'Added new Boss Features: Unstoppable, Heal Block, Mold Breaker, Magic Guard, Attention Grabber.',
    ]
  },
  {
    version: 'Beta 1.1',
    changes: [
      'Added clause for initiative ties.',
      'Moves gained through Symbiosis are revoked if a Pokemon becomes Dual-Type.',
      'Clarified text for Psychosis.',
      'Swapped requirements for Leech Seed and Well of Life.  Buffed Leech Seed usage.',
      'Tombstone now has Sediment Barrier as a prerequisite.',
      'Nerfed usage for Drake\'s Challenge.',
      'Tweaked Retribution.',
      'Reverted Pain Split to previous behavior.',
      'Herbalist may now use Grass levels.',
      'Psyshock has been replaced with Magic Bounce.  Changed prerequisites.',
      'Turbo Charger no longer uses stats.',
      'Still Waters no longer uses stats.',
      'Updated text for the Cover maneuver.',
      'When item crafting Features or Techniques are retrained, the associated items are lost.',
      'Added section for accessory usage conditions under Items.',
      'Clarified Surprise Attack text.',
      'Added “at any time” section under Combat -> Actions.',
      'Added “Multiple Targets” section under Combat -> Attacking.  Added additional info about targeting to the glossary and Triple move style.',
      'Added clause for keeping Features requiring Level requirements after Evolution.',
      'Unified Item text. Items can be used, destroyed, replaced, or dropped.  Multiple Features and the Items -> Using Items section have been updated to reflect these changes.',
      'Added Elixir.',
      'Fixed an issue with Smoke Bombs.',
      'Buffed Stick damage.',
      'Moved Accessories list out of the GM\'s guide and into the items section.',
      'Tweaked Encourage.',
      'Double Team now has time and distance restrictions.',
      'Buffed Fashionable.',
      'Fixed usage for Seeker\'s Gambit.',
      'Fixed an exploit with the Zoom Specs.',
      'Consolidated weapons into a single entry.  Now grant Intermediate Moves & Mastery.',
      'Fixed description for Griseous Mirror.',
      'Adjusted Metal Soul.',
      'Added Ocean Heart, Liquid Armor, Ion Gloves, Eternal Scale, and Royal Crest.'
    ]
  },
  {
    version: 'Beta 1.0',
    changes: [
      'The final set of Features has been added.',
      'Added Glossary.',
      'Reworked Hit Points system.  Pokemon now roll d8 based on the HP stat to determine Hit Points.  The minimum roll for this d8 is 4.',
      'Added Help maneuver.  Improved Encourage.',
      'Added Slight, Tearing, Triple, and Potent Effect Move Styles.',
      'Multi-Hit Move style increased to d8 (was d6)',
      'Burst Move style increased to d10 (was d8)',
      'Odd level-ups now grant a Type Feature generally, instead of only Features from the incremented Type or Mastered Types.',
      'Added Mastery section under Leveling Up.',
      'Temporary Hit Points now expire after any rest, not just Extended Rests.',
      'Updated various Features to use new Saving Throws that scale with level.',
      'Hive Mind now allows you to redistribute stat boosts among your Team.',
      'Removed Aggregate Silk.',
      'Assassination shortened to Assassin',
      'Drake’s Challenge limited to Twice per Battle.  May now use Intimidation skill.',
      'Removed 4 Stat Points from Draconic Blood to align with other recent stat reductions.',
      'Calming Aura can now apply to either Physical or Special stats.',
      'Flash Fire has been removed.',
      'Ignition has been improved.',
      'Pain Split now requires a Standard Action.  Effects improved.',
      'Destiny Bond now has reduced effectiveness against players and bosses.',
      'The Basic Grass Feature now uses the highest Damage Die rolled instead of Grass Level.',
      'Vine Whip now deals 2d8 damage (up from 2d6), and allows you to interact with more than just stray items.  It now has No Prerequisites.',
      'Aromatherapy has been moved to Lv.3.',
      'Bountiful Life now increases healing from a multiplier to including the entire Damage Dice roll.',
      'Apothecary has been replaced with Harvest, a new Lv.5 Feature.',
      'Temp HP for Grassy Terrain is now only added during battles.',
      'Ingrain has been replaced with Well of Life.',
      'Chlorophyll has been made less confusing.  It now lets you use two Grass or powder moves in a single Standard Action.',
      'Wish has been improved.',
      'Misty Terrain has been limited to block only Poison, Freeze, Sleep, Paralysis, and Burn.',
      'Acrobatics is now Aerial Acrobatics to avoid confusion with the Skill.',
      'Changed item determination mechanics for Pickup.  Improved odds.',
      'Just Plain Lucky is now Super Luck.  Moved to Level 9. Can now re-roll any d20.',
      'Black Ice is now Packed Ice. Range reduced.  It now has No Prerequisites.',
      'Flash-Freeze has been moved to Ice Lv.7.',
      'Replaced Bone-Chilling with Winter\'s Kiss.',
      'Shatter buffed due to the removal of Bone-Chilling.',
      'Heal Pulse has been improved.',
      'Renewed Venom is now Toxic Renewal.',
      'Rock-Solid Block now applies to all Move targets, not just one.',
      'Sediment Barrier objects are now referred to as boulders.',
      'Metallurgy now has No Prerequisites.  Cost and duration decreased.',
      'Iron Thorns is now Iron Barbs.',
      'Scald has been removed.',
      'Outfielder now applies to adjacent allies.',
      'Added Skill prerequisite to Leap Ahead.',
      'Added Lockbreaker and Dual Subclass.',
      'Reckless must now be declared before attacking.',
      'Slightly buffed Sitrus berries.',
      'Added Vanish and Eyedrop seeds.',
      'Quick Seed reworked.  Price doubled.',
      'Reviver seeds have been buffed.  Tiny reviver now restores 100% HP.  Reviver now restores Feature usages.  Prices raised.',
      'Apples buffed.',
      'Removed Blinker seed.',
      'Added Golden Thorn, Golden Fossil, Binding Seed, Ban Seed, and Doom Seed.',
      'Reduced price of Scattershot Wand.',
      'Added Meteor Wand.',
      'Trawl Orb range reduced from 100m to 30m.',
      'Buffed Lasso Orb.',
      'Added All-Hit, Pounce, Radar, and Rollcall Orbs.',
      'Reformatted Job rank-up table and added Subclasses section.',
      'Changed Rescuer Diamond-Rank Reward from an Accessory to a Feature.',
      'Added skill points to Intimidator and Taunt.',
      'Can no longer proc Bide with recoil damage.  Reduced potency.',
      'Indomitable Spirit is no longer completely immune to status & stat reductions.',
      'Trap Expert now grants advantage when escaping Obstacles, such as Poison Gas or Whirlpools.',
      'Fixed an issue with Transmutation.',
      'Fixed usage for Moxie.',
      'Declare Duel is now Adjacent and known as Cage Match.',
      'Added section for selling items to the Game Master\'s Guide.',
      'Many changes to Accessories.  Added section to Items regarding Accessories with Usage limits.',
      'Added Wonder Gummi.',
      'Re-ordered Sample Moves to match Features section.'
    ]
  },
  {
    version: 'Alpha 7.2',
    changes: [
      'The Same-Type Attack Bonus has been removed.',
      'Super-Effective Moves now add additional dice per move tier.  Intermediate moves add +2 dice, Advanced moves add +3.  Subtraction of dice is unchanged.',
      'Updated Mastery rules.  Mastery is now gained by Intermediate moves.',
      'The first Advanced Move you learn for a Type also grants a No Prerequisites Feature for that type.',
      'Re-ordered Type Features section to be alphabetical.',
      'Bully now requires a delta of -3 between attacker and defender, instead of a flat -3 to the opponent.',
      'Ruler of Nature now grants moves as well.  Lowered requirements.',
      'Basic Fighting feature now grants additional damage dice to Super-Effective hits.',
      'Demolitionist is now specifically Novice Fire, to account for the effectiveness changes.',
      'Flash Fire now procs on explosions, such as blast traps.',
      'Apothecary now has the correct description.',
      'Helping Hand range reduced from 4>3.  Now works on all allies within range.',
      'Normalize is now Once per Battle, and now applies to every Type the user has Mastery over.',
      'Swapped requirements for Normalize and Born to be a Master due to relaxed Mastery requirements.',
      'Chemical Warfare is now specifically Novice Poison, to account for the effectiveness changes.',
      'Wide Guard is now Lv.9 and only applies if two adjacent allies and the user are targeted.',
      'Tombstone is now Lv.5 and Once per Turn.',
      'Drain is now Once per Turn.',
      'Swapped requirements for Hydration and Scald.',
      'Elemental Expert now grants Mastery on Novice moves.',
      'Replaced stat bonuses at Silver Rank with Rescuer’s Pledge, Explorer’s Findings, and Seeker’s Gambit.',
      'Fixed exploits with Encourage and Taunt.',
      'Brace for Impact is now Prepare for Trouble.  It now grants temp HP when a battle begins, and raises stats when using the Cover maneuver.',
      'Movement from Agile-style Moves is now canceled if the user is Immobilized or Paralyzed.',
      'Gummies now remove all extra dice from type effectiveness, not just one.',
      'The Exhausted condition is no longer cleared by Fainting.',
      'Various changes to higher-tier enemies.',
      'Updated Bag of Tricks to not include Exhausted, Seeded, or other very powerful conditions.',
      'Slightly lowered stat bonus from Evolution and 1-stage starting stats.',
      'Added more information to the table of contents.'
    ]
  },
  {
    version: 'Alpha 7.1',
    changes: [
      'Name and branding have changed from Wanderlust to Tranquility.',
      'Various features and items that reference "Boss" Pokemon now also include information about players.',
      'Fixed a typo in the Job progression table.',
      'Space has been transferred from “Moves” to “Features & Techniques” in the character sheet.  Extra space has also been added.',
      'Redesigned Features and Techniques tables for readability.',
      'Added section about stackable items, and typeless damage from items.',
      'Apple wedges are now Apple slices, and are stackable.  Buffed Big and Perfect apples.',
      'Swapped requirements for Normalize and Helping Hand.',
      'Packed Earth now includes Novice Moves.',
      'Shuffled various requirements for Ground features.',
      'Drenched now triggers on 12 or higher.',
      'Lover\'s Request now targets adjacent Pokemon, forcing them to perform a Cover maneuver.',
      'Empath no longer raises stats if your stats were already raised by that source.',
      'Belch now works with Apple Slices.',
      'Stench now affects all adjacent enemies.',
      'Third rework of Defog.  Hopefully the last one.',
      'Afterimage is now Paranoia.',
      'Imposing Presence is now Drake\'s Challenge.',
      'Brace for Impact is now proc\'d by Protect.  Reduced Temporary HP granted.',
      'Nowhere to Run requires a Standard Action again.',
      'Added Elemental Expert technique.',
      'You can no longer tape Ice Balls together using Mad Scientist.',
      'Added Trickster Seed, Scattershot Wand, and Ginseng.',
      'Increased price of Max Elixirs.',
      'Adjusted Heavy-Duty Boots.',
      'Added "Boss Features" section.  Intermediate and higher Bosses now get a mix of Type Features and Boss Features.'
    ]
  },
  {
    version: 'Alpha 7.0',
    changes: [
      'Minimum damage dice for attacks is now zero.',
      'New progression table for Jobs.',
      'Total overhaul to Rescuer, Explorer, and Seeker Features.',
      'Added Herald, Alchemist and Gladiator Job subclasses.',
      'HP now increases according to Job and Team Rank.',
      'Added new Features for each Type.',
      'Many Features have had prerequisites altered.',
      'Updated descriptions for each Type.',
      'The Cover maneuver now forfeits your next turn, instead of requiring you to use it on your turn.',
      'Basic Grass feature now works with Mastery.',
      'Grassy Terrain now grants 1d6 Temporary Hit Points instead of reducing damage by 1d4.',
      'Removed Meltdown.',
      'Defog now only affects Objects.  You can now use Defog to claim Items on the ground.',
      'You can no longer Jump over Sediment Barrier tiles.',
      'Psionic Blast changed from 1 meter to 5.',
      'Teleport now cures the Immobilized condition.',
      'Added the Sure-Hit condition.  Laser Focus and Miracle Eye now grant the Sure-Hit condition.',
      'Scrap Metal now allows you to produce Iron Thorns as a Standard Action.',
      'Added effect to Standard configuration in Reconfigure Armor.',
      'Shroud of Night can now be activated in dark places, like caves.',
      'Call for Help is now a Free Action.',
      'Endure now prevents fainting instead of Fainting and then reviving you at 1HP.',
      'Changed Rock-Solid Obstacle to Rock-Solid Block to avoid confusion with Obstacles.',
      'Sand Veil now grants allies immunity to Sandstorm damage.',
      'Spikes now has better synergy with Dig.',
      'Snow effect changed from 1d6 to one damage die in reduction.',
      'Snow Veil now grants allies reduced damage in snow.',
      'Removed HP requirement from Retribution.',
      'Outrage can no longer stack with itself.',
      'Triumphant Roar now ignores all Damage Dice instead of ignoring only weaknesses.',
      'Mad Scientist now combines items, instead of duplicating items.',
      'Added Smoke Bomb and Upgrade Seed.',
      'Added Chasm and Meteor Shield Tile Effects.',
      'Changed “Hazards and Fall Damage” to “Direct Damage and Fall Damage” to avoid confusion with the “Hazard” item category.',
      'Various Traps have had their Saving Throws changed.',
      'Added Stat Points to the Standard Set and Allocation for 1-Stage Pokemon.'
    ]
  },
  {
    version: 'Alpha 6.2',
    changes: [
      'Fixed mistaken removal of 3 Skill Points during character creation.',
      'Ingrain now grants Temporary HP instead of damage reduction.',
      'Blunt Exterior now also applies to Special attacks.',
      'Defiance now grants 20 Temporary Hit Points to account for Pokemon with Dragon Mastery.',
      'Added information about the Hit Bonus to the Combat section.',
      'Membership Card now increases bag size to 8 instead of 5.',
      'Bag Sizes in the Job & Team Rank section have been updated.',
      'Added Mega Blast Trap.',
      'Pokemon now may choose between a Normal-Type Move or a Status Move during character creation.',
      'Consequences from traveling over Objects (such as Black Ice and Sticky Webs) are no longer avoidable with the Disengage maneuver.  Try jumping instead!',
      'The "Endurance" skill is now known as "Willpower"',
      'Willpower checks can now be used to delay the "exhausted" status.',
      'Changed "Mixed Attacker" from providing raw stats to adding additional damage to the weaker stat.',
      'Basic Bug feature no longer applies STAB - instead, gain +1 to Hit Bonus for every ally next to your target.',
      'Basic Fighting feature now also adds STAB to the Hit Bonus of super-effective moves.',
      'Changed Caustic Ooze to Caustic Leap, to account for the new Jump maneuver.',
      'Changed Nimble Flier to ignore the double distance restriction, since moving through enemy tiles and jumping over them is mechanically the same.',
      'Tweaked the Evolution in Combat section to award temporary hit points instead of a full heal.',
      'Changed the Jump maneuver.  Instead of being able to Jump for half your travel speed, Jumping now counts as double the distance traveled compared to normal.'
    ],
  },
  {
    version: 'Alpha 6.1',
    changes: [
      'STAB is now a single value that increases whenever a Pokemon levels up to an even level.  It now starts at 1.',
      'Changed wording for character stats.  Characters now have "Stats" that feed into a "Skill Bonus," which is added to "Stage Changes" to result in the "Modifier" for a stat.  "Derived Stats" such as ACS, ACP, Hit Points, and Travel Speed are now referred to as "Combat Information."',
      'Temporary Hit Points have been introduced to a character\'s Combat Info.  Oran and Sitrus berries now grant temporary HP in addition to their normal effects.',
      'Limitless Stamina, Purify, Defiance, and Empath now grant Temporary HP.',
      'Added Jump combat maneuver.',
      'Added section under Combat for hazard and falling damage.',
      'Added “Using Features” section to explain Feature usage limits and prerequisites.',
      'Tweaked Basic Bug, Fighting, and Rock Features.',
      'Shattering Strikes now applies to super-effective hits on full HP targets, instead of on STAB.',
      'Charge now grants two additional damage dice, instead of advantage.',
      'Swapped requirements for Motor Drive and Speedster.',
      'Packed Earth now includes Advanced moves.',
      'Sheer Cold now requires an Ice-Type move to proc.',
      'Rewrote Hive Mind to be more specific and distinct from Entrainment.  It is now Always Active.',
      'Changed High Alert to Early Warning to avoid confusion with Rescuer\'s Alert Feature.',
      'Wingover now allows a choice between the Dash and Evade maneuvers.',
      'Telekinetic now interacts with Items.',
      'Nimble Flier, Ephemeral, and Magnet Rise now grant immunity to falling damage.',
      'Pokemon now recover from Fainting whenever they recover HP.  A Reviver Seed is no longer required.',
      'Reduced prices of Tiny and normal Reviver Seeds, and Sitrus berries.',
      'Bag sizes have been adjusted.  4 items to start, 5 at Bronze, 6 at Silver, 7 at Gold, 8 at Platinum.'
    ]
  },
  {
    version: 'Alpha 6.0',
    changes: [
      'Added Advanced Move Tier.',
      'Added a new mechanic: Type Mastery.  Mastery is gained by knowing an Advanced Move for a Type  Mastery allows you to take Features from that Type during odd level-ups, as long as the Feature has no Level prerequisite.',
      'Intermediate-tier and higher Move Styles are now split into Physical and Special variants  Added Fan Style and Agile Style.',
      'Increased Focused Move Style range to 5m.',
      'Added additional example for Line Style moves.',
      'Added new Type Features for all Types.',
      'Adjusted Saving Throw difficulties for various Features.',
      'Replaced Heatproof with Iron Barbs.',
      'Ruler of Nature now also grants Mastery.',
      'Chemical Warfare now lets you covertly create Grimy Food.',
      'Bountiful Life Super-Effective Critical Hit combo increased from 3x to 5x.',
      'Superconductor changed from Always Active to Once per Turn.',
      'Overshadow now grants you Advantage on all Stealth checks while hidden.',
      'Requirements for many features have been adjusted.',
      'Added Reckless Technique.',
      'Added "Evade" maneuver.',
      'Reduced prices for Oran Berries back down to 100p.',
      'Added "Seeded" and "Blinded" Status Conditions.',
      'Added X-Eye Seed, Trawl Orb, and Spurn Orb.',
      'Added Special Items to the GMs Guide.',
      'Moved "Determining Stats" into the Character Creation section.'
    ]
  },
  {
    version: 'Alpha 5.4',
    changes: [
      'Updated Sample Enemy Moves section in the GM\'s guide.',
      'Fused Talented and Jack of all Trades into one Feature.',
      'Reduced requirements for Top of the Curve.',
      'Re-added Normalize as a new Feature.',
      'Imposing Presence is no longer conditional on Saving Throws.',
      'Level requirement reduced for Sand Force.',
      'Dragon Dance is now Once Per Turn.',
      'Scavenger is now Pickup.',
      'Swapped requirements for Sand Force and Sandstorm (Ground).',
      'Replaced Sand Tomb with Spikes.',
      'Reduced requirements for Mud Sport.',
      'Tweaked Evolution mechanics; if you lose a Type, you can now keep features from the lost Type.',
      'Added Max Elixir and Gummis.',
      'Added Apple Wedge item and slightly tweaked Apple mechanics.',
      'Added Alert Scarf, Eviolite Band, and Life Band. (Credit to lkmdude)'
    ]
  },
  {
    version: 'Alpha 5.3',
    changes: [
      'STAB is now based off half of that Type\'s Level.',
      'General Features are now known as "Techniques".',
      'Updated Features section of Character Creation to revert ruling made in Alpha 52.',
      'Purge changed to Purify, now restores HP instead of increasing Stats.',
      'Increased Saving Throw Difficulty for Disable.',
      'Replaced Mirror Coat with Miracle Eye.',
      'Replaced Counter with Sumo Wrestler.',
      'Reduced Level requirement for Guts.',
      'Basic Fighting Feature now uses half your Fighting-Type Level, instead of 1d4.',
      'Shattering Strikes now adds an additional Damage Die to attacks that are both STAB and Super-Effective (used to add 1d8).',
      'Soak now requires a Saving Throw, not an attack roll.',
      'Keen Eye changed to Mirror Move.',
      'Tailwind now requires Flying Lv3.',
      'Acrobatics now adds an additional damage die, instead of 1d8.',
      'Blaze, Torrent, and Overgrow now add +2 damage dice, instead of 2d6.',
      'Herbalist now recovers 2x the HP stat, instead of 2d8.',
      'Venoshock now adds an additional damage die, instead of 1d6.',
      'Replaced Camouflage with Dig.',
      'Changed the Basic Rock feature to double STAB on consecutive hits, instead of adding 1d4.',
      'Changed Rolling Stone to add additional Damage Dice, instead of increasing die size.',
      'Icy Wind now requires Ice Lv3.',
      'Changed the Basic Bug feature to double STAB when allies are near, instead of adding 1d4.',
      'Metamorphosis now adds +2 and +5 to damage instead of 1d6 and 1d8 when allies are near.',
      'Changed the Basic Dragon feature to an additional damage die when attacking "Boss" Pokémon, instead of 1d6 on evolved Pokémon.',
      'Draconic Blood now increases dice size instead of increasing the Basic Dragon feature from 1d6 to 1d8.',
      'Intimidator is now a Technique.  Added Ruler of Nature.',
      'Retribution now requires Dragon Lv3.',
      'Malice now adds an additional damage die instead of 1d8.',
      'Basic Dark feature now adds an additional damage die before doubling, instead of 1d10 after.',
      'Reduced Level requirement for Mean Look.',
      'Nowhere to Run now adds an additional damage die instead of 1d6.',
      'Calming Aura now only applies if the user wants it to apply.',
      'Mixed Attacker now increases the linked stat by +2 instead of +1.',
      'Added Mad Scientist, Taunt, and Trapmaker Techniques.',
      'Added Typeshift Wand, Two-Edged Wand, and Warp Seed.',
      'Status Moves that reduce stats have had their saving throws removed.  They now always hit.',
      'Paralyzed Pokémon now automatically fail Speed saving throws.',
      'Sleeping and Frozen Pokémon fail all Saving Throws.',
      'Confused Pokémon have disadvantage on all Saving Throws.',
      'Added Disabled condition.',
      'Added Hold maneuver.',
      'Added Poke to the character sheet.',
      'Added section for STAB to the character sheet.',
      'Miscellaneous other changes to the character sheet.'
    ]
  },
  {
    version: 'Alpha 5.2',
    changes: [
      'Added hyperlinks to the Table of Contents.',
      'Added discount prices from the Membership Card feature to the Item List.',
      'Basic Grass and Bountiful Life now use Grass-Type Level for healing instead of d4.',
      'Fortress now allows the user to resist attacks from thrown items.',
      'Power Pitcher now increases wand cast range.',
      'The Thornweave Scarf now deals damage equal to half the incoming attack\'s damage (was 1d6).',
      'Pokemon now always gain one (for dual-types) or two (mono-types) Type Features instead of having the choice between Features and Moves at character creation.',
      'Wonder Orb Saving Throw difficulty has been increased.',
      'If a Wonder Orb is smashed on a tile, any Pokémon standing on that tile automatically fails any Saving Throws for that Orb.'
    ]
  },
  {
    version: 'Alpha 5.1',
    changes: [
      'Added Table of Contents.',
      'Removed "Drop one" from all rolled stats for balance.',
      'Added names to Job Features.'
    ]
  },
  {
    version: 'Alpha 5.0',
    changes: [
      'New look-and-feel for the Character Sheet.',
      'Added 72 new Type Features.',
      'Added Power Pitcher, Adrenaline Junkie, and Stalwart General Features.',
      'Added 12 new Orbs, 2 new Accessories, and a new Wand and Hazard item.',
      'Added Protector, Escape Artist, Merchant, Treasure Hunter, Tracker, and Brawler Job Subclasses.',
      'Added Battlefield Manipulation section.',
      'Added Traps section to the GM\'s Guide.',
      'Normal-Type Pokemon now start with a Move from any Type.',
      'Stat Stages now modify damage by 1 per stage, instead of 2.',
      'Rescuer and Protector features changed from "+2 ACS, +2 ACP, or +1 to both" to "Attacks that meet your ACP or ACS exactly result in a miss".',
      'Normalize changed to Helping Hand.',
      'Guts changed to Laser Focus.',
      'Toxic Ooze now harms Pokémon that start their turn on it.',
      'Outrage changed from Once per Battle to Twice per Extended Rest.',
      'Imposing Presence should now occur less often.',
      'Ephemeral now reduces damage from battlefield objects.',
      'Frightening also restricts Feature usage.',
      'Defiance changed from +3 Stages to +6 Stages.',
      'Avenger changed from +1 Stages to +2 Stages.',
      'Keen Eye now prevents Attack and Special Attack from being lowered.',
      'High Alert now gives a bonus to Perception, instead of Keen Eye.',
      'Changed Apple mechanics and prices.',
      'Improved AC for enemies.',
      'Renamed "Accessory & Key Item Storage" to "Storage Box".'
    ]
  },
  {
    version: 'Alpha 4.4',
    changes: [
      'Clarified text for various parts of the book, especially Character Creation and Moves.',
      'Effect Move range reduced from 4m to 3m.',
      'Added rules for retraining a Move\'s Type during Extended Rests.',
      'Added rules for Surprise Attacks.',
      'Added the "Immobilized" and "Exhausted" Status Conditions.',
      'Added graphics explaining Move Styles.',
      'Added note about Friendly Fire to the Frozen condition.',
      'Added Ambush and Leap Ahead General Features.',
      'Type Expert changed to Camaraderie.',
      'Demolitionist changed from "add a d6" to "add an extra die".',
      'Sharp Falling Style changed to Intense Style.',
      'Wide Falling Style changed to Suppress Style.',
      'Basic Rock Feature now requires you to hit any target with a Rock-Type Move, instead of the same target with any attack.',
      'Outsider now lets you move up to your Travel Speed in meters while off the field.',
      'Removed HP bonus from Herbalist  Herbalist can now apply to Restoratives used on allies.',
      'Soak may now affect the Same-Type Attack Bonus (STAB).',
      'Normalize may now remove all changes, not just positive changes.'
    ]
  },
  {
    version: 'Alpha 4.3',
    changes: [
      'Same-Type Attack Bonus now applies to all Pokémon, not just Mono-Type Pokémon.',
      'Added the "Combat Maneuvers" system, and updated various game elements to use it.',
      'Removed many restrictions related to learning new Moves.',
      'Rewrote and added names to all Features  Choose from a pool of features instead of a binary choice at every level.',
      'More Features are now available during Character Creation.',
      'Hyper Healing now shortens the Extended Rest time to 4 hours.',
      'Brittle Crystal changed from "You may take Opportunity Attacks against Pokemon that move away from a Frozen Pokemon" to "Your teammates have Advantage when attacking a target you have Frozen".',
      'Removed Attack bonus from Follow Through.',
      'Talented increased from one new move to two.',
      'Reworked the previous Ground feature into Sand Veil.',
      'Removed General Features dealing with Evolution and Moves.',
      'Added "Progression through Evolution" to the GM\'s Guide.',
      'Clarified definitions for Advantage, Disadvantage, and Free Actions.',
      'Opportunity Attacks now only use Novice Moves.',
      'Added bonus Skill Points to Normal Rank.',
      'Moved Bronze Rank skills to Silver Rank to make room for Job Subclass features. (coming soon!)'
    ]
  },
  {
    version: 'Alpha 4.2',
    changes: [
      'Replaced video game stats with three stat derivation methods: rolling, allocation, and standard sets  See Playing The Game -> Determining Stats for details.',
      'Changed style names for all Status Moves.',
      'Evolution now adds stats to your existing character, instead of starting you from scratch.',
      'Total visual overhaul of the Character Sheet, courtesy of @hinezume.',
      'Changed Normal Lv6 Feature #1 -- Normal-Type moves may now remove certain enemy stat stages instead of ignoring enemy stat stages.',
      'Changed Normal Lv6 Feature #2 -- Item prices increased to 100p and 500p respectively.',
      'Reduced Stat Points floor from 40pts to 30pts, and reduced the number of starting Skill Points from 6 to 3.',
      'Reduced power of enemies in Enemy Creation.',
      'Added extended rests  Extended rests now dictate Feature usage frequency, and allow swapping between Features and Move Styles.',
      'Added Chari Bombs and Slumber Wands.',
      'Added Effect Move: Swagger.',
      'Added eight new Rare Accessories.'
    ]
  },
  {
    version: 'Alpha 4.1',
    changes: [
        'Changed Unranked Job features  Rescuers, Explorers, and Seekers now gain benefits to some Skill Checks in Towns, the Wilds, or Dungeons, respectively.',
        'Critical Failures due to Confusion now occur on 8 or below, instead of 6.',
        'Changed flavor text for the Types section.',
        'Added Totter Seed.',
        'Added Fleetfoot Scarf and Apple Belt.',
        'Added two new General Features.',
        'Using a Reviver Seed while Fainted is now a Free Action and does not end your turn.',
        'Quick Orbs now raise Speed two stages (was 1).',
        'Removed Rollcall Orb.',
        'Added link to serebiinet page for Cyndaquil in Character Creation.',
        'Added "Gathering a Team" to the Playing The Game section.',
        'Initiative bonus is now determined by "Speed Modifier".',
        'Different Move Ranges are now referred to as "Move Styles".',
        'Novice Damaging Moves only have one Style -- "Simple Style".',
        'Novice Status Moves can choose between "Raise Style" and "Fall Style".',
        'Intermediate Damaging Moves choose between "Focused Style," "Sweeping Style," and "Line Style".',
        'Intermediate Status Moves choose between "Camaraderie Style," "Fastfall Style," and "Widefall Style".',
        'Added graphics to illustrate ranges for different Move Styles.',
        'Added Friendly Fire information to several Move Styles and the Combat section.',
        'Reduced Focused Style move range from 6m to 4m.',
        'Ground-Type Lv4 Feature #2 (turn single-target attacks into a 2x2) has been replaced with "Intermediate Ground-Type Moves always use d8\'s for their Damage Dice, regardless of Move style"  The old Feature will be re-introduced at a later level.',
        'Swapped Lv4 Ground-Type Feature #2 and Lv6 Ground-Type Feature #1.'
    ]
  },
  {
    version: 'Alpha 4.0',
    changes: [
        'You must now be Character Level 5 or higher to use General Feature #7.',
        'General Feature #10 now increases your Level by 2 (was 1).',
        'Vile and Violet Seeds now have a delta of 3 Stat Stages (was 2).',
        'Added a small description for Status Conditions.',
        'Added text for throwing non-standard items.',
        'Added Lv6 Type Features and Lv7 Learned Moves.',
        'Rewrote Types section to add room for future Features.',
        'Added Bronze Rank Job Features.',
        'Added 11 more Consumable Items.',
        'Added Legendary accessories, as well as a number of Rare and Common accessories (total of 46 new accessories).',
        'Moved Accessories List to the Game Master\'s Guide.',
        'Pokémon may now Evolve.',
        'Rewrote Player Balance section to support Evolution.'
    ]
  },
  {
    version: 'Alpha 3.1',
    changes: [
      'Improved Job descriptions in Character Creation (Thanks, Latula!).',
      'Nerfed Apples, and added Big and Perfect variants.',
      'Clarified text for Lv4 Ground Feature 2.',
      'Updated Move creation in Moves as well as in Character Creation.',
      'Reduced Damage Dice for Intermediate Damaging Moves to 2d8 (was 3d8).',
      'Doubled Range for the Switcher Wand.',
      'Increased base Saving Throw Difficulty for all Status Moves.',
      'Changed Dark-Type Lv2 Feature from 2d10 back to 1d10.',
      'Moved Skill descriptions from the Game Master\'s Guide to Playing The Game.',
      'Added General Features.',
      'Added sample Moves to the Game Master\'s Guide.'
    ]
  },
  {
    version: 'Alpha 3.0',
    changes: [
      'Clarified Skill definition in Character Creation.',
      'Buffed Infatuation; there is now an accuracy penalty when attacking other targets.',
      'Lowered price for Confusion Wands.',
      'Fainting now removes Poisoning and Burns.',
      'Added sections for Saving Throws and Key Item / Accessory Storage to the character sheet.',
      'Added "Mission Difficulty" and additional enemy types to the Game Master\'s Guide.',
      'Temporary Stat Modifiers have been overhauled and replaced with the Stage Changes system.',
      'Removed the Focus skill.',
      'Novice Status Moves now have a limit of ±3 stages.',
      'Added Level 4 Type Features.',
      'Added Intermediate Moves.',
      'Added Effect Moves.',
      'Added Accessories.'
    ]
  },
  {
    version: 'Alpha 2.2',
    changes: [
      'Added "Sitrus Berry" and nerfed "Oran Berry".',
      'Added definitions for "Adjacent" and "Dice Size".',
      'Renamed "Jobs &amp; Guild Rank" to "Jobs &amp; Team Rank".',
      'Updated definitions for various Berries and Wands.',
      'Clarified Dark and Normal type Lv2 Features.',
      'Reduced price of Heal Seed to 100p.',
      'Added section about "Character Level".',
      'Changed "Shift Speed" to "Travel Speed".',
      'Added information about progression to the Game Master\'s Guide.',
      'Improved Introduction.',
      'Added Skills and Skill Checks.'
    ]
  },
  {
    version: 'Alpha 2.1',
    changes: [
      'Added +5 Speed modifier to Quick Seed.',
      'You may now forfeit a Standard Action to instead take another Shift Action.',
      'Moved the "Leveling Up" and "Types" sections farther down.',
      'Changed the Difficulty of Novice Status Moves to be set at 15 instead of calculated using Stats.',
      'Status Move Difficulty can no longer be changed by Empowerment or Draining.',
      'Added "Enemy Creation" to the Game Master\'s Guide.',
      'Reduced Wonder Orb effect range from 6 to 4 meters.',
      'Reduced price of Blast Wands from 50p to 25p.',
      'Reduced Poison damage back to 1d8 from 1d10.',
      'Fixed a formatting issue with the character sheets.',
      'Added note about item scarcity to the Game Master\'s Guide.',
      'The Normal Lv2 feature now increases dice size by 2 instead of replacing d6\'s with d8\'s.',
      'Reviver Seeds can now be used on Pokémon who are not Fainted.',
      'Added the \'Normal\' Team Rank.'
    ]
  },
  {
    version: 'Alpha 2.0',
    changes: [
        'Revised "Item Bag" section of character sheet.',
        'Added Stat Modifiers to all stats on the character sheet (Except HP).',
        'Renamed "Held Items" to "Accessories".',
        'Updated character creation to reflect new changes.',
        'Removed Basic Attacks from the game.',
        'Added section explaining Ranged Attacks.',
        'The Fighting-Type Level 2 feature was changed from "Basic Attacks use a d8 instead of a d4" to "Super-effective hits add an additional d4 to Damage Dice".',
        'The Water-Type Level 2 feature was changed from "Water Attacks push targets back 1 meter" to "Water Attacks lower the target\'s Defense, Special Defense, or Speed 3 points on 15 or higher".',
        'Throwing items to friendly Pokémon no longer requires an Attack Roll.',
        'Changed Burned status to inflict recoil damage when using Moves, instead of when attacking.',
        'Relocated details about adding and subtracting dice due to type effectiveness to the "Moves" section.',
        'Changed Rookie Explorer feature from "Cannot critically fail when using an item" to "Attack rolls involving items have Advantage".',
        'Added Unranked Features to Explorer, Rescuer, and Seeker.',
        'Oran Berry prices have increased from 100p to 150p.',
        'Initiative rolls now involve Shift Speed instead of the Speed stat.',
        'Critical Failure recoil damage has been changed to only occur while Confused, and has been increased to 2d6.',
        'Added Saving throws.',
        'Added Novice Status moves.',
        'Added Temporary Stat Changes, as well as Drained and Empowered stats.',
        'Moved the Leveling Up section above the Types section and added the Learned Moves chart.',
        'Replaced references to "Elemental" moves to instead say "Damaging" moves.',
        'Added Quick Seed, Gravelerock, Sleep Seed, Violent Seed, Vile Seed, Switcher Wand, Whirlwind Wand, Confuse Wand, Blast Wand, Rollcall Orb, Luminous Orb, Petrify Orb, Slumber Orb, All Protect Orb, and Revive All Orb to the Item List.',
        'Various grammar improvements and clarifications.'
    ]
  },
  {
    version: 'Alpha 1.2',
    changes: [
        'Revised wording of item usage in the Attacking section.',
        'Added "Shift Distance" and "Status Conditions" to the character sheet.',
        'Changed Oran Berry description from "3d8 Hit Points" to "Full Hit Points".',
        'Changed Apple description from "1d8 Hit Points" to "3d8 Hit Points".',
        'Increased Hit Point multiplier from 4x stat value to 5x stat value.',
        'Pokemon now require five hours of Resting to recover full Hit Points.',
        'Fainting now removes non-permanent Status Conditions.',
        'Poison damage increased from 1d8 to 1d10.',
        'Paralyzed Pokemon may now either use a Shift or Standard action, but not both  Previously, they could only use a Standard action.',
        'Attack rolls now add half the relevant Attack stat to attack rolls instead of the entire stat  Damage is unchanged.',
        'Updated character tutorial with new attack information, Shift calculation, and Status Condition section.',
        'Clarified text for Rock-type Level 2 Feature.',
        'Buffed Steel-type Level 2 Feature to require 17 AC instead of 18.',
        'Revised Initiative explanation.',
        'Added clarification to "Taking Damage" to account for the attack roll change.',
        'Added section to "Leveling Up" reminding the player to recalculate derived stats.',
        'Changed Rookie Explorer feature from "Add 2d8 to healing/damaging items" to "cannot critically fail when using an item".',
        'Type effectiveness is no longer a multiplier, and instead adds and removes dice.',
        'Removed all references to "Damage Rolls," replacing them with the term "Damage Dice rolls".'
    ]
  },
  {
    version: 'Alpha 1.1',
    changes: [
        'Added ACP/ACS acronyms to their section in Character Creation section.',
        'Added damage formula to Taking Damage section.',
        'Added 5 Hit Point requirement to Level 2 Grass feature.'
    ]
  }
]